import {Modal} from 'antd'
import axios from 'axios'
import {getUserInfo} from '@/utils/common'
import {alert, sendLogoutLogOnceFromUserInfo} from "@/utils/utils"
import env from '@/config/env'

let alertNoUser = false

let updateBaseInfo = async () => {
    return true
}

export const setUpdateBaseInfoFn = (fn) => {
    updateBaseInfo = fn
}

export const runUpdateBaseInfo = async (request) => {
    if (!['/jxs/user/login', '/jxs/user/currentUser','/backstage/sms/send.do','/fxs/user/loginSjhWeb','/fxs/user/currentUser'].includes(request.url)) {
        return updateBaseInfo()
    }
}

export const allRequestAddJxsxx = async (request) => {
    const userinfo = getUserInfo()
    if (['/jxs/user/login', '/jxs/user/currentUser','/backstage/sms/send.do','/fxs/user/loginSjhWeb','/fxs/user/currentUser', '/manage/dcyxSysLog/add'].includes(request.url)) {
        return request
    }
    if(!userinfo || !userinfo.jxsid || !userinfo.jxsxx || !userinfo.jxsxx.partner) {
        if(!alertNoUser) {
            alertNoUser = true
            await sendLogoutLogOnceFromUserInfo()
            Modal.info({
                title: '提示',
                content: '登录已过期，需要重新登录',
                onOk() {
                    window.location.reload()
                },
            });
        }
        return Promise.reject(new Error('login'))
    }
    if(!(await runUpdateBaseInfo(request))) {
        return Promise.reject(new Error('login'))
    }
    // if(userinfo.jxsid) {
    //   request.headers.jxsid = userinfo.jxsid
    // }
    // if(userinfo.jxsxx && userinfo.jxsxx.partner) {
    //   request.headers.partner = userinfo.jxsxx.partner
    // }
    // if(userinfo.sysid) {
    //   request.headers.dlid = userinfo.sysid
    // }
    if (!request.params) {
        request.params = {}
    }
    if (!request.data) {
        request.data = {}
    }
    if ((request as any).autojxs !== false && ['/backstage/', '/frontend/'].every(r => !request.url.startsWith(r))) {
        if (request.method === 'get') {
            if (!request.params.jsid && userinfo.jsid) {
                request.params.jsid = userinfo.jsid
            }
            if (!request.params.jxsid && userinfo.jxsid) {
                request.params.jxsid = userinfo.jxsid
            }
            if (!request.params.partner && userinfo.jxsxx && userinfo.jxsxx.partner) {
                request.params.partner = userinfo.jxsxx.partner
            }
            if (!request.params.jsid && userinfo.jsid) {
                request.params.jsid = userinfo.jsid
            }
            // 分页形式
            if (request.params.param && request.params.page) {
                if (!request.params.param.jsid && userinfo.jsid) {
                    request.params.param.jsid = userinfo.jsid
                }
                if (!request.params.param.jxsid && userinfo.jxsid) {
                    request.params.param.jxsid = userinfo.jxsid
                }
                if (!request.params.param.jsid && userinfo.jsid) {
                    request.params.param.jsid = userinfo.jsid
                }
                if (!request.params.param.partner && userinfo.jxsxx && userinfo.jxsxx.partner) {
                    request.params.param.partner = userinfo.jxsxx.partner
                }
            }
        } else if (request.method === 'post') {
            if (!request.data.jsid && userinfo.jsid) {
                request.data.jsid = userinfo.jsid
            }
            if (!request.data.jxsid && userinfo.jxsid) {
                request.data.jxsid = userinfo.jxsid
            }
            if (!request.data.partner && userinfo.jxsxx && userinfo.jxsxx.partner) {
                request.data.partner = userinfo.jxsxx.partner
            }
            if (!request.params.jsid && userinfo.jsid) {
                request.params.jsid = userinfo.jsid
            }
            // 分页形式
            if (request.data.param && request.data.page) {
                if (!request.data.param.jsid && userinfo.jsid) {
                    request.data.param.jsid = userinfo.jsid
                }
                if (!request.data.param.jxsid && userinfo.jxsid) {
                    request.data.param.jxsid = userinfo.jxsid
                }
                if (!request.data.param.jsid && userinfo.jsid) {
                    request.data.param.jsid = userinfo.jsid
                }
                if (!request.data.param.partner && userinfo.jxsxx && userinfo.jxsxx.partner) {
                    request.data.param.partner = userinfo.jxsxx.partner
                }
            }
        }
    }
    if ((request as any).ssgsbm !== false && userinfo && userinfo.jxsxx && userinfo.jxsxx.ssgsbm) {
        request.params.ssgsbm = 2200
    }
    return request
}

export const responseError = (e) => {
    if(e.message !== 'login') {
        Modal.warning({
            title: e.config && e.config.url || '提示',
            content: e.message || '处理异常，请稍后再试'
        })
    }
    throw e
}

const http = axios.create({
    baseURL: env.BASE_URL,
    // credentials: 'include',
    withCredentials: true,
})

http.interceptors.request.use(allRequestAddJxsxx)

http.interceptors.response.use((response) => {
    if (response.data && ['succeed', 'ok'].includes(response.data.status)) {
        response.data.status = true
    } else if (response.data && ['failed', 'fail'].includes(response.data.status)) {
        response.data.status = false
    }
    if ((response.config as any).autopass) {
        return response.data
    }
    if (!(response.config as any).uncheck && !response.data.status) {
        Modal.warning({
            title: '提示',
            content: response.data.msg || response.data.errmsg || '处理异常，请稍后再试'
        })
    }
    return response.data
},responseError)

const request = (url, params = {}) => {
    return http(url, params) as any
}

export default request
